import styled from "styled-components";
import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";
export const VideoContainer = styled.div`
	margin: ${({ margin }) => (margin ? margin : "")};
	height: 346px;
	${media.lessThan(breakpoints.mobile)`
	height: 200px;

button{
    height: 40px;
    width: 40px;
    i{
        font-size: 30px;
    }
}
    h1{
        margin-left: 20px;
        font-size: 16px;
        line-height: 24px;
        
    }
`}
`;
export const MockButton = styled.div`
	width: 20px;
	height: 20px;
	align-self: flex-start;
	background-color: rgba(255, 255, 255, 0.9);
	padding: 15px 15px 15px 15px;
	border-radius: 50px;
	display: flex;
	border: none;
	margin: 10px;

	align-items: center;
	cursor: pointer;

	justify-content: center;

	i {
		margin-left: 5px;

		transition: 0.2s ease;

		font-size: 24px;
		color: ${({ theme }) => theme.colors.iconColor};
	}
`;
